"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../styles");
var UniqProducts = function (props) {
    return (react_1.default.createElement(styles_1.Section, null,
        react_1.default.createElement(styles_1.SectionTitle, null,
            "\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0435 ",
            props.productNamePlural,
            " \u0441 \u0444\u043E\u0442\u043E\u043F\u0435\u0447\u0430\u0442\u044C\u044E"),
        props.seoText));
};
var SUniqProducts = (0, styled_components_1.default)(UniqProducts)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", " {\n        margin-top: 24px;\n    }\n"], ["\n    ", " {\n        margin-top: 24px;\n    }\n"])), styles_1.Link);
exports.default = SUniqProducts;
var templateObject_1;
